<template>
  <div>
    <Discount></Discount>
  </div>
</template>

<script>
import Discount from '@/components/discount.vue'
export default {
  name: 'Test',
  components: {
    Discount
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  }

}
</script>

<style scoped lang='less'>
h1 {
  color: #fff;
}
</style>
